import { Controller } from '@hotwired/stimulus'

// Autofocus element when Boostrap dropdown is shown
// For example
//
//  <button data-controller="bootstrap-dropdown-autofocus" data-bs-toggle="dropdown">
//    Dropdown
//  </button>
//
//  <div class="dropdown-menu">
//    <input type="text" autofocus>   <-- autofocused when the dropdown is shown
//  </div>
export default class extends Controller {
    connect() {
        this._onShown = this.handleShown.bind(this)
        this.element.addEventListener('shown.bs.dropdown', this._onShown)
    }

    disconnect() {
        this.element.removeEventListener('shown.bs.dropdown', this._onShown)
    }

    handleShown() {
        const instance = bootstrap?.Dropdown?.getInstance?.(this.element)
        if (instance && instance._menu instanceof Element) {
            const menu = instance._menu

            const autofocusEl = menu.querySelector('[autofocus]')
            if (autofocusEl) {
                autofocusEl.focus({ preventScroll: true })
                if (typeof autofocusEl.select === 'function') {
                    autofocusEl.select()
                }
            }
        }
    }
}
